import Helpers from '../inc/Helpers';
import Ajax from '../inc/Ajax';

class Newsletter {
    constructor() {
        this.helpers = new Helpers();
        this.ajax = new Ajax();
    }

    init() {
        let self = this;

        self.handleSubscribe();
    }

    handleSubscribe() {
        let self = this;

        let submitBtn = $('.newsletter .col-submit .btn');

        submitBtn.on('click', function (e) {
            e.preventDefault();

            let thisBtn = $(this);
            let block = thisBtn.closest('.newsletter');
            let overlay = block.find('.ajax-overlay');
            let emailInput = block.find('.col-input input[type="text"]');

            let data = {
                email: emailInput.val()
            };

            const done = function () {
                emailInput.val('');
                block.find('.success')
                     .html('Inscription effectuée avec succès')
                     .show()
                ;
            };

            const fail = function (response) {
                self.helpers.formErrors(block, response.responseJSON.errors);
            };

            const always = function () {
                overlay.fadeOut(150);
            };

            self.helpers.cleanFormMessages(block);
            overlay.fadeIn(150);

            self.ajax.post('/api/newsletter/subscribe', 'JSON', data, done, fail, always);
        });
    }
}

export default Newsletter;